<p class="typography-body-small text-text-common-base">
  {{ displayText() }}
</p>
